import { ApplicationRef, ChangeDetectorRef, Component, OnInit, NgZone } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { environment } from '../environments/environment';
import { fader } from './route-animation';
import { ImgcamService } from './services/imgcam.service';
import { SupaService, UserPermissions } from './services/supa.service';
import { TranslateService } from '@ngx-translate/core';
import { HelperService } from './services/helper.service';
import { Deeplinks } from '@ionic-native/deeplinks/ngx';
import { App, URLOpenListenerEvent } from '@capacitor/app'
import { Subject } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  animations: [
    fader
  ]
})
export class AppComponent implements OnInit {

  currentUrl = '';
  isWCamMode = false;
  userpermissions$ = this.supa.LoginObject;
  langMenuOpen = false;

  constructor(
    private router: Router,
    public imgcam: ImgcamService,
    public supa: SupaService,
    private cdr: ChangeDetectorRef,
    public translate: TranslateService,
    public helper: HelperService,
    public deeplinks: Deeplinks
  ) {
    this.translate.setDefaultLang('en');
    this.translate.langs.push('kr');
    this.translate.langs.push('ar');
    this.router.events.subscribe((event: any) => {
      if (event instanceof NavigationEnd) {
        this.currentUrl = event.urlAfterRedirects;
        this.cdr.detectChanges();
      }
    });
  }

  ngOnInit(): void {
    localStorage.removeItem('EXTCONF');
    localStorage.removeItem('SETTINGS');

    this.supa.CreateRecordByParam.subscribe(async lo => {
      if (lo != -1) {
        const jcId = lo;
        console.log('App component got request for new record', lo);
        this.supa.CreateRecordByParam.next(-1);

        const recordData = await this.supa.supabase.from('vhc_vhcrecord').select('id').eq('jobcard_id', jcId).limit(1).maybeSingle();
        if (recordData.data) {
          this.router.navigateByUrl('/vhc-record;id=' + recordData.data.id)
        } else {
          const newjcdata = await this.supa.supabase.from('jobcard').select('vehicle_vin,iqlocation_id').eq('id', jcId).limit(1).maybeSingle();
          if (newjcdata.data) {
            console.log('Should make a new record with this jc data:', newjcdata);
            this.helper.createNewRecord(newjcdata.data.vehicle_vin, jcId, newjcdata.data.iqlocation_id);
          }
        }
      }
    })
  }

  setlang(code) {
    this.langMenuOpen = false;
    this.translate.use(code)
  }

  menuOpened(e) {
    var event = new MouseEvent('mouseover', {
      'view': window,
      'bubbles': true,
      'cancelable': true
    });
    e.target.dispatchEvent(event);
  }

  visible(url) {
    return this.currentUrl.startsWith(url);
  }

  hasSubmenu() {
    return this.currentUrl.startsWith('/settings');
  }

  prepareRoute(outlet: RouterOutlet) {
    return outlet && outlet.activatedRouteData
  }
}
